import { useNumberFormat } from 'hooks/useNumberFormat';
import { TApplication } from 'lendingApi/applications.types';
import { showApprovalAmount } from '../../ApplicationsTableState.context.helpers';

type TProps = {
  application: TApplication;
};

export const ApprovalAmountCell = ({ application }: TProps) => {
  const { formatCurrency } = useNumberFormat();

  const approvalAmount =
    application.formal_offer_sets?.[0]?.formal_offers?.[0]?.max_amount;

  if (approvalAmount && showApprovalAmount(application.status)) {
    return <div>{formatCurrency(approvalAmount)}</div>;
  }

  return '-';
};
